import React, { Component } from "react";
import { connect } from "react-redux";
import { ActionCreator } from "../../../../actions/actions";
import { AuthActionCreators } from "../../actions/actionCreators";
import { authStoreSelectors } from "../../store/store";
import { AuthPageStrings } from "./AuthPage.strings";
import LoginCard from "./LoginCard/LoginCard.component";
import RecoverCard from "./RecoverCard/RecoverCard.component";
import SignupCard from "./SignupCard/SignupCard.component";
import Suggestion from "./Suggestion/Suggestion.component";

export const availablePages = ["Login", "Signup", "Recover"];

export interface AuthPageState {
    currentPage: string;
}
export interface AuthPageProps {
    redirectLogin: boolean;
    clearRedirect: ActionCreator;
}

class AuthPage extends Component<AuthPageProps, AuthPageState> {
    constructor(_props) {
        super(_props);
        this.state = {
            currentPage: availablePages[0]
        };
    }

    componentDidMount() {
        this.props.clearRedirect();
    }

    onChangePage = pageIndex => {
        this.setState({
            currentPage: availablePages[pageIndex]
        });
    };

    render() {
        let currentCard;

        if (this.state.currentPage === "Signup") {
            currentCard = (
                <SignupCard
                    onChangePage = {this.onChangePage}
                    suggestion={
                        <div>
                            <Suggestion
                                onAnchorClick={() => this.onChangePage(0)}
                                questionText={
                                    AuthPageStrings.ALREADY_HAVE_ACCOUNT
                                }
                                anchorText={AuthPageStrings.LOGIN}
                            />
                        </div>
                    }
                />
            );
        } else if (this.state.currentPage === "Recover") {
            currentCard = (
                <RecoverCard
                    onChangePage = {this.onChangePage}
                />
            );
        } else {
            currentCard = (
                <LoginCard
                    onChangePage = {this.onChangePage}
                    suggestion={
                        <div>
                            <Suggestion
                                onAnchorClick={() => this.onChangePage(2)}
                                questionText=""
                                anchorText={AuthPageStrings.RECOVER}
                            />
                        </div>
                    }
                />
            );
        }

        return currentCard;
    }
}

const mapStateToProps = state => ({
    redirectLogin: authStoreSelectors.redirectLogin(state),
    clearRedirect: AuthActionCreators.clear_redirect
});

export default connect(mapStateToProps)(AuthPage);
